import { render, staticRenderFns } from "./ColorModuleHeader.vue?vue&type=template&id=9923a0ae&scoped=true"
import script from "./ColorModuleHeader.vue?vue&type=script&lang=ts"
export * from "./ColorModuleHeader.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleHeader.vue?vue&type=style&index=0&id=9923a0ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9923a0ae",
  null
  
)

export default component.exports